"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconWithLabel = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledIconWithLabel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 16px;\n  box-sizing: border-box;\n  display: inline-flex;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  align-items: center;\n  margin-right: ", ";\n  padding: 0 2px;\n\n  span {\n    padding-left: 2px;\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: normal;\n    color: ", ";\n  }\n"], ["\n  height: 16px;\n  box-sizing: border-box;\n  display: inline-flex;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  align-items: center;\n  margin-right: ", ";\n  padding: 0 2px;\n\n  span {\n    padding-left: 2px;\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: normal;\n    color: ", ";\n  }\n"])), function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Secondary.inactive;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.secondary;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.x4;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.fontFamiily;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xs;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.dark;
});
var templateObject_1;
